<div class="dialog-hld">
  <div mat-dialog-title class="mat-dialog-title">
    <div class="title">{{ "translateSelectLanguage" | translate }}</div>
  </div>

  @if (currentLanguage(); as selectedLanguage) {
    <div mat-dialog-content class="lang-modal-hld">
      <div class="lang-dropdown-hld">
        <div class="dropdown-btn" mat-button [matMenuTriggerFor]="languageMenu">
          <div class="clang-hld">
            @if (checkFlagIcon(selectedLanguage)) {
              <mat-icon svgIcon="flags/{{ selectedLanguage }}" class="app-icon-hover">
              </mat-icon>
            }
            <span class="padd-l-10">{{ selectedLanguage | translate }}</span>
          </div>
          <mat-icon svgIcon="arrow_down" class="dropdown-icon"></mat-icon>
        </div>
        <mat-menu #languageMenu="matMenu" class="panel-full-width">
          @for (language of languageHelperService.availableLanguages; track language) {
            <button mat-menu-item class="lang-hld"
              (click)="selectLanguage(language)">
              <ng-container>
                @if (checkFlagIcon(language)) {
                  <mat-icon svgIcon="flags/{{ language }}" class="app-icon-hover"></mat-icon>
                }
              </ng-container>
              {{ language | translate }}
            </button>
          }
        </mat-menu>
      </div>
    </div>
  }

  <div mat-dialog-actions class="modal-footer">
    <div (click)="close()" class="action-btn">
      {{ "translateCancel" | translate }}
    </div>
    <div (click)="save()" class="action-btn">
      {{ "translateSave" | translate }}
    </div>
  </div>
</div>
